import React from "react";
import { Popconfirm } from "antd";
import { CheckOutlined, CloseOutlined, ExportOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../Components/Items";
import ListaTicketsSoporte from "../../Panel/Soporte/Chat/ListaTicketsSoporte";
import ConversacionMovil from "../../Panel/Soporte/Chat/ConversacionMovil";
import ChipsFase from "../../Panel/Soporte/Chat/ChipsFase";
import InfoReporte from "../../Panel/Soporte/Chat/InfoReporte";
import TagFase from "../../Panel/Soporte/Chat/TagFase";
import TagRespuestaCliente from "../../Panel/Soporte/Chat/TagRespuestaCliente";
import FormularioAprobacionJira from "../../Panel/Soporte/Chat/FormularioAprobacionJira";
import { SOPORTE_TEMA, chatCerrado, textoChatCerradoAgente } from "../../Panel/Soporte/Chat/fasesSoporte";

const EnlaceJira = ({ jiraKey, jiraBaseUrl }) => {
    if (!jiraKey) return null;
    if (!jiraBaseUrl) return <span style={{ fontSize: 11, color: SOPORTE_TEMA.textSecondary }}>{jiraKey}</span>;
    return (
        <a
            href={`${jiraBaseUrl}/browse/${jiraKey}`}
            target="_blank"
            rel="noreferrer"
            style={{ fontSize: 11, whiteSpace: "nowrap" }}
        >
            {jiraKey} <ExportOutlined />
        </a>
    );
};

const BandejaSoporteMovil = ({
    // Lista
    tickets,
    loading,
    opcionesFase,
    faseFiltro,
    onCambiarFase,
    hayMas,
    cargandoMas,
    onCargarMas,
    usuarioId,
    onSeleccionar,
    // Conversación
    ticketSeleccionado,
    mensajes,
    loadingMensajes,
    enviandoMensaje,
    onVolver,
    onEnviarMensaje,
    jiraBaseUrl,
    // Aprobación
    catalogos,
    valores,
    onCambiarValor,
    faltaTipoIncidencia,
    aprobando,
    rechazando,
    onAprobar,
    onRechazar,
}) => {
    const esPendiente = ticketSeleccionado?.fase === "pre_reporte";
    const cerrado = chatCerrado(ticketSeleccionado?.fase);

    if (!ticketSeleccionado) {
        return (
            <div style={{ backgroundColor: SOPORTE_TEMA.surface, borderRadius: 7, overflow: "hidden" }}>
                <div style={{ padding: "10px 12px", borderBottom: `1px solid ${SOPORTE_TEMA.border}` }}>
                    <div style={{ fontSize: 15, fontWeight: 600, color: SOPORTE_TEMA.textPrimary, marginBottom: 8 }}>
                        Tickets de Soporte
                    </div>
                    <ChipsFase opciones={opcionesFase} valor={faseFiltro} onChange={onCambiarFase} />
                </div>
                <ListaTicketsSoporte
                    tickets={tickets}
                    loading={loading}
                    onSelect={onSeleccionar}
                    mostrarReportero
                    usuarioId={usuarioId}
                    modoSoporte
                    header={null}
                    anchoTexto="100%"
                    pieDeLista={
                        hayMas ? (
                            <div style={{ textAlign: "center", padding: 12 }}>
                                <ButtonItem type="default" azul loading={cargandoMas} onClick={onCargarMas}>
                                    Cargar más
                                </ButtonItem>
                            </div>
                        ) : null
                    }
                />
            </div>
        );
    }

    return (
        <ConversacionMovil
            titulo={ticketSeleccionado.titulo}
            meta={
                <>
                    <TagFase fase={ticketSeleccionado.fase} />
                    <TagRespuestaCliente respuesta={ticketSeleccionado.respuestaCliente} />
                    <span
                        style={{
                            fontSize: 11,
                            color: SOPORTE_TEMA.textSecondary,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {ticketSeleccionado.folio}
                        {ticketSeleccionado.empresaId?.nombre ? ` · ${ticketSeleccionado.empresaId.nombre}` : ""}
                    </span>
                    <EnlaceJira jiraKey={ticketSeleccionado.jiraKey} jiraBaseUrl={jiraBaseUrl} />
                </>
            }
            onVolver={onVolver}
            mensajes={mensajes}
            loadingMensajes={loadingMensajes}
            enviando={enviandoMensaje}
            onEnviar={onEnviarMensaje}
            perspectivaAgente
            soloLectura={cerrado}
            textoSoloLectura={cerrado ? textoChatCerradoAgente(ticketSeleccionado.fase) : undefined}
            etiquetaAccion={esPendiente ? "Revisar" : "Reporte"}
            resaltarAccion={esPendiente}
            panelTitulo={esPendiente ? "Revisar y dar de alta en Jira" : "Detalle del reporte"}
            panelContenido={(cerrarPanel) => (
                <>
                    <InfoReporte ticket={ticketSeleccionado} mostrarPasos={!esPendiente} mostrarNotasInternas perspectivaAgente />

                    {esPendiente && (
                        <>
                            <FormularioAprobacionJira
                                ticket={ticketSeleccionado}
                                catalogos={catalogos}
                                valores={valores}
                                onCambiar={onCambiarValor}
                            />

                            {faltaTipoIncidencia && (
                                <div style={{ fontSize: 11, color: SOPORTE_TEMA.textSecondary, margin: "10px 0 6px" }}>
                                    Escoge el tipo de incidencia de Jira para poder aprobar
                                </div>
                            )}
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 10,
                                    marginTop: 12,
                                    paddingTop: 12,
                                    borderTop: `1px solid ${SOPORTE_TEMA.border}`,
                                }}
                            >
                                <Popconfirm
                                    title="¿Aprobar este ticket y crear el Issue en Jira?"
                                    onConfirm={onAprobar}
                                    okText="Sí"
                                    cancelText="No"
                                    disabled={faltaTipoIncidencia}
                                >
                                    <ButtonItem
                                        verde
                                        block
                                        icon={<CheckOutlined />}
                                        loading={aprobando}
                                        disabled={faltaTipoIncidencia}
                                    >
                                        Aprobar
                                    </ButtonItem>
                                </Popconfirm>
                                <ButtonItem
                                    cyanB
                                    block
                                    icon={<CloseOutlined />}
                                    loading={rechazando}
                                    onClick={() => {
                                        cerrarPanel();
                                        onRechazar();
                                    }}
                                >
                                    Cerrar reporte
                                </ButtonItem>
                            </div>
                        </>
                    )}
                </>
            )}
        />
    );
};

export default BandejaSoporteMovil;
